/* eslint react/no-danger: 0, no-unused-expressions: 0, consistent-return: 0, react/button-has-type: 0 */
import React, { useRef, useEffect, useState, useCallback } from 'react';
import logo from '../images/logo-mobile.svg';
import xIcon from '../images/white-x-icon.svg';
import { isEs } from "../libs/lang";

const content = isEs() ? require('../contentES').default : require('../content').default;
/* eslint-disable global-require */

const TopRibbon = ({closeExitOverlay,transcript}) => {

	const btnXicon = useRef(null);

	useEffect(() => {
		// set focus to x close icon upon overlay opening
		btnXicon.current && btnXicon.current.focus();
	});

	let transcriptHeader = isEs() ? 'Transcripción' : 'Transcript';

	return (<div id="modal-top-ribbon" className={`${transcript == 'hero' ? 'transcript' : ''}`}>
		{
			transcript == 'hero' ? <p>{transcriptHeader}</p> : <img className="logo" src={logo} alt="Wells Fargo logo."/>
		}
		<button id="modal-x-icon" onClick={closeExitOverlay} ref={btnXicon} type="button">
			<img src={xIcon} alt="Closes the overlay window."/>
		</button>
	</div>)
}

// aria-live="polite"
const ModalBody = ({videoID, showTranscripts, videoType, videoPath, captionPath, transcript}) => (

	<div id="modal-body" className={`${transcript !== false ? 'transcript-body' : ''}`}>
	{(() => {

		if (!videoID && transcript === false) {
			return (<>
				<p id="dialogTitle" className="modal-headline" role="heading">{content.modal.title}</p>
				<p id="dialogDesc">{content.modal.description}</p>
			</>)
		}

		if(transcript !== false && transcript !== undefined){
			if (isEs()) {
				return (<>
					<div className="transcript-copy">
						<p>0:00</p>
						<p>En Wells Fargo, creemos que haciendo se marca la diferencia.</p>
						<p>0:04</p>
						<p>Y por eso hemos donado mås de $2,000 millones en los últimos cinco años para fortalecer las comunidades locales, desde más de $710 millones para ayudar a la asequibilidad de la vivienda, cerca de $420 millones para ayudar a propietarios de pequeñas empresas a través de organizaciones sin fines de lucro, hasta unos $58 millones en apoyo a becas y programas extracurriculares para estudiantes.</p>
						<p>0:25</p>
						<p>Porque somos el banco para ir con todo.</p>
					</div>
				</>)
			} else {
				return (<>
					<div className="transcript-copy">
						<p>0:00</p>
						<p>At Wells Fargo, we believe that doing can make a difference.</p>
						<p>0:04</p>
						<p>That's why we've donated over $2 billion to strengthen local communities over the last five years, from more than $710 million to help address housing access and affordability, to roughly $420 million to help small business owners through nonprofits, to nearly $58,000,000 to support scholarships and programming for students.
						</p>
						<p>0:25</p>
						<p>Because doing gets it done.</p>
					</div>
				</>)
			}
		}

		if (videoType === 'vimeo') {
			return (<>

				<div style={{padding: "75% 0 0 0", position: "relative"}}>
					<iframe title={Math.random().toString()} src={`https://player.vimeo.com/video/${videoID}`} style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%'}} frameBorder="0" allow="fullscreen; picture-in-picture" allowFullScreen/>
				</div>
				<script src="https://player.vimeo.com/api/player.js"/>
				<button
					id="modal-view-transcript"
					className="view-transcript"
					aria-expanded="false"
					aria-controls="widget1"
					type="button"
					onClick={() => {
						showTranscripts();
					}}
				>Transcript
				</button>
				<div
					aria-live="assertive"
					role="region"
					id="widget1"
					className={`transcript-text`}
					aria-hidden="true"
					dangerouslySetInnerHTML={{__html: content.videos[videoID].transcript}}
				/>
			</>)
		}
		if (videoType === 'youtube') {
			return (<>

				<div style={{padding: "75% 0 0 0", position: "relative"}}>
					<iframe src={`https://www.youtube.com/embed/${videoID}`} title={Math.random().toString()} style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%'}} frameBorder="0" allow="fullscreen; picture-in-picture" allowfullscreen></iframe>
				</div>
				<script src="https://www.youtube.com/iframe_api"/>
				<button
					id="modal-view-transcript"
					className="view-transcript"
					aria-expanded="false"
					aria-controls="widget1"
					type="button"
					onClick={() => {
						showTranscripts();
					}}
				>Transcript
				</button>
				{
					 content.videos[videoID] && (
						<div
						aria-live="assertive"
						role="region"
						id="widget1"
						className={`transcript-text`}
						aria-hidden="true"
						dangerouslySetInnerHTML={{__html: content.videos[videoID].transcript}}
					/>
					 )
				}

			</>)
		}
		if (videoType === 'hosted') {

			return (<>

				<div style={{padding: "0 0 0 0", position: "relative"}}>
					<video controls style={{width: '100%'}}>
						<source src={videoPath} type="video/mp4"/>
						<track
							default
							kind="captions"
							srcLang="en"
							label="On"
							src={captionPath}
						/>
					</video>
				</div>


				<button
					id="modal-view-transcript"
					className="view-transcript"
					aria-expanded="false"
					aria-controls="widget1"
					type="button"
					onClick={() => {
						showTranscripts();
					}}
				>Transcript
				</button>
				<div
					aria-live="assertive"
					role="region"
					id="widget1"
					className={`transcript-text`}
					aria-hidden="true"
					dangerouslySetInnerHTML={{__html: content.videos[videoID].transcript}}
				/>
			</>)
		}

	})()}

</div>)



const BottomLinks = ({
						 closeExitOverlay, continueLink, transcript
					 }) =>
					 (
							transcript == 'hero' ? null : <>
														<div className="modal-links">

<button id="modal-cancel" onClick={closeExitOverlay} aria-label="cancel button - closes the overlay window">{isEs() ? 'Cancele' : 'Cancel'}</button>

<a id="modal-continue" onClick={closeExitOverlay} href={continueLink} target="_blank" rel="noreferrer" aria-label="continue button opens link in new browser window">{isEs() ? 'Continúe' : 'Continue'} </a>

</div>
							</>
						)


const ModalOverlay = ({closeExitOverlay, modalOverlay, isYouTube, videoType}) => {

	const refOverlay = useRef(null);

	const showTranscripts = () => {

		if (refOverlay.current.classList.contains('transcript-open')) {
			refOverlay.current.classList.remove('transcript-open')
			refOverlay.current.tabIndex = null;
		}
		else {
			refOverlay.current.classList.add('transcript-open');
			refOverlay.current.tabIndex = 0;
		}
		const btnTranscript = document.querySelector('button.view-transcript');
		btnTranscript.classList.toggle('open');
		const curAriaExp = btnTranscript.getAttribute('aria-expanded');
		const isExpanded = (curAriaExp === 'true');
		btnTranscript.setAttribute('aria-expanded', String(!isExpanded));

		const divTranscript = document.querySelector('.transcript-text');
		divTranscript.classList.toggle('open');
		const curAriaHidden = divTranscript.getAttribute('aria-hidden');
		const isHidden = (curAriaHidden === 'true');

		if (!isHidden) {
			divTranscript.setAttribute('aria-hidden', 'true');
		}
		else {
			divTranscript.removeAttribute('aria-hidden');
		}

	}


	useEffect(() => {
		///////////////////////////////////////////////////////
		// Accessibility Requirement
		// Traps tab key in modal when it is open.
		///////////////////////////////////////////////////////

		console.log(modalOverlay);

		const overlayDiv = refOverlay.current;
		overlayDiv.addEventListener('keydown', e => {
			const lastElem = modalOverlay.videoID ? document.getElementById('modal-view-transcript') : document.getElementById('modal-continue');
			switch (e.which) {
				case 9: { // tab key
					if (e.shiftKey) {
						if (document.activeElement.id === 'modal-x-icon') {
							e.preventDefault();
							lastElem.focus();
						}
					}
					else {
						if (document.activeElement.id === lastElem.id) {
							e.preventDefault();
							document.getElementById('modal-x-icon').focus();
						}
					}
					break;
				}
				case 27: { // ESC key
					closeExitOverlay();
					break;
				}
				default: {
					break;
				}
			}
		});

		overlayDiv.classList.add('fade-in');

	});

	return (<div id="overlay">
		<div
			id="modal"
			ref={refOverlay}
			className={`${modalOverlay.transcript == 'hero' ? 'transcript' : null} ${modalOverlay.videoID ? 'has-video' : ''} ${isEs() ? 'es' : ''}`}
			role="dialog"
			aria-labelledby={!modalOverlay.videoID ? 'dialogTitle' : undefined}
			aria-describedby={!modalOverlay.videoID ? 'dialogDesc' : undefined}
		>
			<>

				<TopRibbon
					closeExitOverlay={closeExitOverlay}
					transcript={modalOverlay.transcript}
				/>
				<ModalBody
					videoID={modalOverlay.videoID}
					videoType={modalOverlay.videoType}
					showTranscripts={modalOverlay.videoID ? showTranscripts : false}
					videoPath={modalOverlay.videoPath || ''}
					captionPath={modalOverlay.captionPath || ''}
					transcript={modalOverlay.transcript}
				/>
				{!modalOverlay.videoID && (<BottomLinks
					transcript={modalOverlay.transcript}
					closeExitOverlay={closeExitOverlay}
					continueLink={modalOverlay.continueLink}
				/>)}
			</>


		</div>
	</div>);
}

export default ModalOverlay;
